<template>
    <div>
        <h1>
            Logged Out
        </h1>
        <p>
            You have successfully Logged out
        </p>
    </div>
</template>
<script>

export default {
  components: {
  },
  data () {
    return {
      //
    }
  },
    created() {
        localStorage.removeItem("user");
        localStorage.removeItem("customers");
        localStorage.removeItem("access_token");
        this.$store.dispatch('logout')
        window.location = '/';
    }
}
</script>
